// extracted by mini-css-extract-plugin
export default {"Text":"TermsOfUse_Text__FOJgt"};